import CheckboxGroup from './CheckboxGroup';
// import Error from './Error'
import FormGroup from './FormGroup';
import Input from './Input';
import RadioGroup from './RadioGroup';
import Select from './Select';

export default {
    CheckboxGroup,
    //Error,
    FormGroup,
    Input,
    RadioGroup,
    Select
};
